export const getBannerSessionV2Query = `
  query{
    asset(id: "j7z5etv1V2X71hurWEO4B"){
      url
    }
  }
`
